function splitStringAtFirstComma(str) {
  const i = str.indexOf(',');
  return [str.substring(0, i + 1), str.substring(i + 1)];
}

export default splitStringAtFirstComma;
